<template>
  <div>
    <a-tabs default-active-key="1">
      <a-tab-pane key="1">
    <span slot="tab">
      <a-icon type="contacts"/>
      Referencias
    </span>
    <a-row :gutter="[16, 16]">
      <a-col :span="24">
        <a-card>
          <div v-if="$getConfigValue('MOSTRAR_ALERTA_BIODATA_REFERENCIAS', 'NO') === 'SI'">
            <a-alert
              :message="$getConfigValue('MENSAJE1_ALERTA_REFERENCIAS')"
              :description="$getConfigValue('MENSAJE2_ALERTA_REFERENCIAS')"
              type="info"
              show-icon
            />
            <br>
          </div>
          <g-master name="BiodataReferencias"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    :parentData="evParentData"
                    :beforeSend="master.beforeSend"
                    @action="masterAction"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
              <a-col v-bind="col2Options">
                <a-form-item :label="$t('Nombre')">
                  <a-input
                    class="ant-uppercase"
                    v-decorator="['full_name', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="col2Options">
                <a-form-item :label="$t('Dirección')">
                  <a-textarea placeholder="Dirección"
                              class="ant-uppercase"
                              readOnly
                              autoSize
                              :disabled="isDisabledDireccion"
                              v-model="address"
                              v-on:click="modalDireccionVisible = true">
                  </a-textarea>
                </a-form-item>
              </a-col>
              <a-col v-bind="col2Options">
                <a-form-item :label="$t('Ocupación')">
                  <a-input
                    class="ant-uppercase"
                    v-decorator="['job', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="col2Options">
                <a-form-item :label="$t('Teléfono')">
                  <a-input
                    class="ant-uppercase"
                    v-decorator="['phone', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
                </a-form-item>
              </a-col>
              </a-row>
            </template>
          </g-master>
        </a-card>
      </a-col>
    </a-row>
    <direccion-estructurada v-model="address" :visible="modalDireccionVisible"
                            @cancel="modalDireccionVisible = false"
                            @success="direccionCambiada"></direccion-estructurada>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  export default {
    data () {
      return {
        isDisabledDireccion: this.$getConfigValue('BIODATA_REFERENCIA_DIRECCION_DISABLED', false) === 'SI',
        address: null,
        modalDireccionVisible: false,
        id_h_relationship: {
          h_lookup_type: 'PARENTESCO'
        },
        colOptions: {xs: 24, sm: 8},
        col2Options: {xs: 24, sm: 12},
        master: {
          beforeSend: (data) => {
            data.address = this.address
            return data
          },
          endpoint: 'personreferences',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_person_ref'
            },
            columns: [
              {title: 'Nombre', dataIndex: 'full_name', sorter: true},
              {title: 'Dirección', dataIndex: 'address', sorter: true},
              {title: 'Ocupación', dataIndex: 'job', sorter: true},
              {title: 'Teléfono(s)', dataIndex: 'phone', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado', dataIndex: 'modified_on', sorter: true}
              // upc value se muestra cuando UPC tiene S
            ]
          },
          modalFieldsSetup: [
            {name: 'full_name'},
            {name: 'address'},
            {name: 'job'},
            {name: 'phone'}
          ]
        }
      }
    },
    props: ['persona'],
    computed: {
      evParentData () {
        return {
          id_person: this.persona
        }
      }
    },
    methods: {
      direccionCambiada () {
        this.modalDireccionVisible = false
      },
      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            this.address = ''
            break
          case 'masterEdit':
            if (!JsUtils.isEmpty(action.record.address)) {
              this.address = action.record.address
            }
            break
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Biodata/BiodataReferencias.vue